const url = typeof window !== 'undefined' ? window?.location?.href : '';
const testOmsId = url.match(/[0-9]{9}/g);
const draftId = url.match(/\?draftProductId=([0-9]+)\&?/i);
const omsId = draftId ? draftId[1] : testOmsId ? testOmsId[0] : null;
export default omsId ; 
